import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dashboardpenel',
  templateUrl: './dashboardpenel.component.html',
  styleUrls: ['./dashboardpenel.component.scss']
})
export class DashboardpenelComponent implements OnInit {

  feature:any = null;

  constructor() { 
      
  }

  ngOnInit(): void {
    
  }
}